module.exports = __webpack_public_path__ + "static/media/discount.bc749bf5.svg";